import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router';
import './styles/fonts.css';
import './styles/app.css';
import './styles/pages.css';
import './styles/simple.css';
import { Shell } from './app/Shell';
import { RequireAuth, Login } from './app/Login';
import { Dashboard } from './pages/Dashboard';
import { StudioPage } from './studio/Studio';
import { ScreensPage } from './pages/Screens';
import { TimetablePage } from './pages/Timetable';
import { SettingsPage } from './pages/Settings';
import { DisplayPage } from './pages/Display';
import { NotFound, RouteError } from './app/Errors';
import { DeviceGate } from './app/DeviceGate';
import { backend, useApp } from './data/store';

const router = createBrowserRouter([
  { path: '/display', element: <DisplayPage />, errorElement: <RouteError /> },
  { path: '/login', element: <DeviceGate passwordLinks><Login /></DeviceGate>, errorElement: <RouteError /> },
  {
    path: '/',
    element: <DeviceGate><RequireAuth><Shell /></RequireAuth></DeviceGate>,
    errorElement: <RouteError />,
    children: [
      { index: true, element: <Dashboard /> },
      { path: 'studio', element: <StudioPage /> },
      { path: 'studio/:screenId', element: <StudioPage /> },
      { path: 'screens', element: <ScreensPage /> },
      { path: 'timetable', element: <TimetablePage /> },
      { path: 'settings', element: <SettingsPage /> },
      { path: 'settings/:tab', element: <SettingsPage /> },
      { path: '*', element: <NotFound /> },
    ],
  },
]);

// Restore the saved sign-in before the first render, so pages never flash the sign-in screen.
void backend.ready().finally(() => {
  useApp.setState({ session: backend.session() });
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <RouterProvider router={router} />
    </StrictMode>,
  );
});
